import { render, staticRenderFns } from "./datatable.vue?vue&type=template&id=76bf792b"
import script from "./datatable.vue?vue&type=script&lang=js"
export * from "./datatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports